import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

interface IFormProps extends TestingProps {
  children?: React.ReactNode;
  inline?: boolean;
  className?: string;
  onSubmit?: (e: React.FormEvent) => void;
}

export const Form: React.FunctionComponent<IFormProps> = ({
  children,
  className,
  onSubmit,
  testId,
}) => {
  return (
    <form
      onSubmit={onSubmit}
      className={C('form', className && className)}
      data-testid={testId}
    >
      {children}
    </form>
  );
};
